///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2023 - 2023
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import { includes, sumBy } from "lodash";

export const mapLaneCarrierCapacityMatch = (
  capacityMatches,
  rowsSelected,
  isNoneOptionSelected,
  laneMatches,
  clearExistingMatches
) => {
  let laneCarrierCapacityMatches = [];
  const laneInfo = capacityMatches?.filter(x =>
    includes(rowsSelected, x.truckloadLaneId)
  );

  if (isNoneOptionSelected || clearExistingMatches) {
    laneInfo.map(lane => {
      return laneCarrierCapacityMatches.push({
        laneId: lane.truckloadLaneId,
        shipperLaneId: lane.shipperLaneId,
        carrierMatches: [],
        none: isNoneOptionSelected
      });
    });
  } else {
    laneInfo.map(lane => {
      let carrierMatches = [];
      const laneMatchesOnALane = laneMatches.filter(
        x => x.truckloadLaneId === lane.truckloadLaneId
      );

      laneMatchesOnALane.map(laneMatch => {
        return carrierMatches.push({
          carrierId: laneMatch.carrierId,
          carrierName: laneMatch.carrierName,
          carrierCode: laneMatch.carrierCode,
          incumbent: laneMatch.incumbent,
          odLoadingTypes: sumBy(laneMatch.odLoadingTypes, "value"),
          equipmentType: laneMatch.equipmentType.value,
          assetType: laneMatch.assetType.value,
          weeklyCap: laneMatch.weeklyCap,
          carrierRate: laneMatch.carrierRate,
          notes: laneMatch.notes
        });
      });

      return laneCarrierCapacityMatches.push({
        laneId: lane.truckloadLaneId,
        shipperLaneId: lane.shipperLaneId,
        carrierMatches
      });
    });
  }

  return laneCarrierCapacityMatches;
};

export default mapLaneCarrierCapacityMatch;
